import { fromJS } from 'immutable'

import { FETCH_NOTES } from './constants'
import { LOCATION_CHANGE } from 'react-router-redux'

import { tabChanged } from 'scenes/VehicleDetail/utils'

export const initialState = fromJS({
  notes_list: []
})


export default function reducer(state = initialState, action) {
  switch(action.type){
    case FETCH_NOTES:
      return state.set('notes_list', action.notes_list)
    case LOCATION_CHANGE:
      return tabChanged(action.payload, 'siniestro', state, initialState)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Notes/reducer.js